import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import Router from './pages/Router';

function SuporteWhatsapp() {
    const [visivel, setVisivel] = useState(true);

    if (!visivel) return null;

    return (
        <a
            className="fixed left-0 bottom-0 w-28 h-28 rounded-full z-[999] block bg-transparent bg-center bg-no-repeat animate-slide-right "
            style={{
                backgroundImage: 'url(/suporte.png)',
                backgroundSize: '73%',
                fontSize: 0
            }}
            target="_blank"
            name="suporteLink"
            rel="noreferrer"
            title="Suporte via WhatsApp"
            href="https://wa.me/+554733356679?text=Ol%C3%A1%2C%20estou%20precisando%20de%20suporte."
        >
            {/* Botão X dentro do componente animado */}
            <button
                onClick={(e) => {
                    e.preventDefault(); // impede de abrir o link
                    setVisivel(false);
                }}
                className="absolute flex items-center justify-center w-4 h-4 font-mono text-xs font-bold text-gray-700 bg-white rounded-full hover:bg-red-400 hover:text-white top-4 right-4"
                title="Fechar"
            >
                x
            </button>
            Suporte Whatsapp
        </a>
    );
}


function App() {
    return (
        <div className="h-screen text-sm bg-yellow-50">
            <Router />
            <Toaster position="top-right" reverseOrder={true} />
            <SuporteWhatsapp />
        </div>
    );
}

export default App;
